import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Popup } from 'semantic-ui-react';
import styles from '../Playlist.scss';
import Song from './';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

class SongList extends Component {
  static propTypes = {
    innerRef: PropTypes.object,
    playlist: PropTypes.object,
    removeFromPlaylist: PropTypes.func,
    importSpotifyRef: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.focusSearch = this.focusSearch.bind(this);
    this.importSpotify = this.importSpotify.bind(this);
  }

  focusSearch() {
    document.querySelector('#songSearch input').focus();
  }

  importSpotify() {
    this.props.importSpotifyRef.current.click();
  }

  render() {
    const { innerRef, playlist, removeFromPlaylist } = this.props;
    const numSongs = playlist.playlist_songs.edges.length;

    const deleteButton = (
      <Popup
        content='Remove from Playlist'
        inverted
        position='left center'
        trigger={
          <Button
            className={styles.noBoxShadow}
            circular
            basic
            type='button'
            size='small'
            icon='delete'
          />
        }
      />
    );

    const Row = ({ index, style }) => {
      const playlistSong = playlist.playlist_songs.edges[index].node;
      return (
        <div style={style}>
          <Song
            key={index}
            song={playlistSong.song}
            actionCallback={removeFromPlaylist}
            actionTrigger={deleteButton}
            parent={playlistSong}
          />
        </div>
      );
    };

    const itemSize = 120;
    const maxHeight = 270;
    let playlistHeight = playlist.playlist_songs.edges.length * itemSize;
    if (playlistHeight > maxHeight) playlistHeight = maxHeight;

    return (
      <div>
        {numSongs === 0 &&
          <div style={{ padding: '2em 0' }}>
            <p className={styles.emptyList}>
              This playlist has no songs.<br />
              <a onClick={this.focusSearch}>Search</a> or{' '}
              <a onClick={this.importSpotify}>import from Spotify</a> to add
              songs.
            </p>
          </div>}
        <div style={{ height: `${playlistHeight}px`, width: '100%' }}>
          <AutoSizer>
            {({ height, width }) =>
              <List
                height={height}
                width={width + 16}
                itemCount={playlist.playlist_songs.edges.length}
                itemSize={78}
                ref={innerRef}
              >
                {Row}
              </List>}
          </AutoSizer>
        </div>
      </div>
    );
  }
}

export default React.forwardRef((props, ref) =>
  <SongList innerRef={ref} {...props} />
);



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Song/Songs.js